export const geocodeLocation = (location) => {
  return fetch(process.env.REACT_APP_GEOCODE_LOCATION, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(location)
  }).then((response) => response.json());
};
